var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "schdoi",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "boliartr granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "boliartr diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "boliartr andesit",
  "block.minecraft.grass_block": "grasblock",
  "block.minecraft.dirt": "erd",
  "block.minecraft.coarse_dirt": "grobe erd",
  "block.minecraft.podzol": "saure erd",
  "block.minecraft.crimson_nylium": "karmesin-nezel",
  "block.minecraft.warped_nylium": "wirr-nezel",
  "block.minecraft.cobblestone": "bruchschdoi",
  "block.minecraft.oak_planks": "aichaholzbrettla",
  "block.minecraft.spruce_planks": "fichdaholzbrettla",
  "block.minecraft.birch_planks": "biakaholzbrettla",
  "block.minecraft.jungle_planks": "dropaholzbrettla",
  "block.minecraft.acacia_planks": "akaziaholzbrettla",
  "block.minecraft.dark_oak_planks": "schvarzaichaholzbrettla",
  "block.minecraft.crimson_planks": "karmesinbretter",
  "block.minecraft.warped_planks": "wirrbretter",
  "block.minecraft.oak_sapling": "aichabaimle",
  "block.minecraft.spruce_sapling": "fichdabaimle",
  "block.minecraft.birch_sapling": "biakabaimle",
  "block.minecraft.jungle_sapling": "dropabaimle",
  "block.minecraft.acacia_sapling": "akaziabaimle",
  "block.minecraft.dark_oak_sapling": "schvarzaichabaimle",
  "block.minecraft.bedrock": "grundgschdoi",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "roatr sand",
  "block.minecraft.gravel": "kis",
  "block.minecraft.gold_ore": "golderz",
  "block.minecraft.iron_ore": "aisaerz",
  "block.minecraft.coal_ore": "schdoikole",
  "block.minecraft.nether_gold_ore": "nethergolderz",
  "block.minecraft.oak_log": "aichakloba",
  "block.minecraft.spruce_log": "fichdakloba",
  "block.minecraft.birch_log": "biakakloba",
  "block.minecraft.jungle_log": "dropabaumkloba",
  "block.minecraft.acacia_log": "akaziakloba",
  "block.minecraft.dark_oak_log": "schvarzaichakloba",
  "block.minecraft.crimson_stem": "karmesinstiel",
  "block.minecraft.warped_stem": "wirrstiel",
  "block.minecraft.stripped_oak_log": "gschältr aichakloba",
  "block.minecraft.stripped_spruce_log": "gschältr fichdakloba",
  "block.minecraft.stripped_birch_log": "gschältr biakakloba",
  "block.minecraft.stripped_jungle_log": "gschältr dropabaumkloba",
  "block.minecraft.stripped_acacia_log": "gschältr akaziakloba",
  "block.minecraft.stripped_dark_oak_log": "gschältr schvarzaichakloba",
  "block.minecraft.stripped_crimson_stem": "geschälter karmesinstiel",
  "block.minecraft.stripped_warped_stem": "geschälter wirrstiel",
  "block.minecraft.stripped_oak_wood": "gschälts aichaholz",
  "block.minecraft.stripped_spruce_wood": "gschälts fichdaholz",
  "block.minecraft.stripped_birch_wood": "gschälts biakaholz",
  "block.minecraft.stripped_jungle_wood": "gschälts dropaholz",
  "block.minecraft.stripped_acacia_wood": "gschälts akaziaholz",
  "block.minecraft.stripped_dark_oak_wood": "gschälts schvarzaichaholz",
  "block.minecraft.stripped_crimson_hyphae": "geschälte karmesinhyphen",
  "block.minecraft.stripped_warped_hyphae": "geschälte wirrhyphen",
  "block.minecraft.oak_wood": "aichaholz",
  "block.minecraft.spruce_wood": "fichdaholz",
  "block.minecraft.birch_wood": "biakaholz",
  "block.minecraft.jungle_wood": "dropaholz",
  "block.minecraft.acacia_wood": "akaziaholz",
  "block.minecraft.dark_oak_wood": "schvarzaichaholz",
  "block.minecraft.crimson_hyphae": "karmesinhyphen",
  "block.minecraft.warped_hyphae": "wirrhyphen",
  "block.minecraft.oak_leaves": "aichablättla",
  "block.minecraft.spruce_leaves": "dåsnådla",
  "block.minecraft.birch_leaves": "biakablättla",
  "block.minecraft.jungle_leaves": "dropabaumblättla",
  "block.minecraft.acacia_leaves": "akaziablättla",
  "block.minecraft.dark_oak_leaves": "schvarzaichablättla",
  "block.minecraft.sponge": "schvamm",
  "block.minecraft.wet_sponge": "nassr schvamm",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapislazulierz",
  "block.minecraft.lapis_block": "lapislazuliblock",
  "block.minecraft.dispenser": "verfr",
  "block.minecraft.sandstone": "sandschdoi",
  "block.minecraft.chiseled_sandstone": "gmaisltr sandschdoi",
  "block.minecraft.cut_sandstone": "gschnittanr sandschdoi",
  "block.minecraft.note_block": "notablock",
  "block.minecraft.powered_rail": "ådriabsglais",
  "block.minecraft.detector_rail": "sensorglais",
  "block.minecraft.sticky_piston": "bäppiga kolba",
  "block.minecraft.cobweb": "schbinnanetz",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "farn",
  "block.minecraft.dead_bush": "frrecktr boscha",
  "block.minecraft.seagrass": "seagras",
  "block.minecraft.sea_pickle": "meeresgurke",
  "block.minecraft.piston": "kolba",
  "block.minecraft.white_wool": "vaise voll",
  "block.minecraft.orange_wool": "oråschane voll",
  "block.minecraft.magenta_wool": "rosaroate voll",
  "block.minecraft.light_blue_wool": "hellblaue voll",
  "block.minecraft.yellow_wool": "geale voll",
  "block.minecraft.lime_wool": "hellgreane voll",
  "block.minecraft.pink_wool": "rosane voll",
  "block.minecraft.gray_wool": "graue voll",
  "block.minecraft.light_gray_wool": "hellgraue voll",
  "block.minecraft.cyan_wool": "blaugreane voll",
  "block.minecraft.purple_wool": "lillane voll",
  "block.minecraft.blue_wool": "blaue voll",
  "block.minecraft.brown_wool": "braune voll",
  "block.minecraft.green_wool": "greane voll",
  "block.minecraft.red_wool": "roate voll",
  "block.minecraft.black_wool": "schvarze voll",
  "block.minecraft.dandelion": "levazå",
  "block.minecraft.poppy": "mon",
  "block.minecraft.blue_orchid": "blaue orchidea",
  "block.minecraft.allium": "ziarlauch",
  "block.minecraft.azure_bluet": "borzellanschderala",
  "block.minecraft.red_tulip": "roate dulpa",
  "block.minecraft.orange_tulip": "oråschane dulpa",
  "block.minecraft.white_tulip": "vaise dulpa",
  "block.minecraft.pink_tulip": "rosane dulpa",
  "block.minecraft.oxeye_daisy": "margerite",
  "block.minecraft.cornflower": "korabloama",
  "block.minecraft.lily_of_the_valley": "maigleckle",
  "block.minecraft.wither_rose": "withr-ros",
  "block.minecraft.brown_mushroom": "braunr bilz",
  "block.minecraft.red_mushroom": "roatr bilz",
  "block.minecraft.crimson_fungus": "karmesinpilz",
  "block.minecraft.warped_fungus": "wirrpilz",
  "block.minecraft.crimson_roots": "karmesinwurzeln",
  "block.minecraft.warped_roots": "wirrwurzeln",
  "block.minecraft.nether_sprouts": "nethersprossen",
  "block.minecraft.weeping_vines": "trauerranken",
  "block.minecraft.twisting_vines": "zwirbelranken",
  "block.minecraft.sugar_cane": "zuckrror",
  "block.minecraft.kelp": "seadang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goldblock",
  "block.minecraft.iron_block": "aisablock",
  "block.minecraft.oak_slab": "aichaholzschdäffale",
  "block.minecraft.spruce_slab": "fichdaholzschdäffale",
  "block.minecraft.birch_slab": "biakaholzschdäffale",
  "block.minecraft.jungle_slab": "dropaholzschdäffale",
  "block.minecraft.acacia_slab": "akaziaholzschdäffale",
  "block.minecraft.dark_oak_slab": "schvarzaichaholzschdäffale",
  "block.minecraft.crimson_slab": "karmesinstufe",
  "block.minecraft.warped_slab": "wirrstufe",
  "block.minecraft.stone_slab": "schdoischdäffale",
  "block.minecraft.smooth_stone_slab": "glatts schdoischdäffale",
  "block.minecraft.sandstone_slab": "sandschdoischdäffale",
  "block.minecraft.cut_sandstone_slab": "gschnittanes sandschdoischdäffale",
  "block.minecraft.petrified_oak_slab": "frschdoinarts aichaholzschdäffale",
  "block.minecraft.cobblestone_slab": "bruchschdoischdäffale",
  "block.minecraft.brick_slab": "ziaglschdäffale",
  "block.minecraft.stone_brick_slab": "schdoiziaglschdäffale",
  "block.minecraft.nether_brick_slab": "nethrziaglschdäffale",
  "block.minecraft.quartz_slab": "kvarzschdäffale",
  "block.minecraft.red_sandstone_slab": "roats sandschdoischdäffale",
  "block.minecraft.cut_red_sandstone_slab": "gschnittanes roats sandschdoischdäffale",
  "block.minecraft.purpur_slab": "burpurschdäffale",
  "block.minecraft.prismarine_slab": "brismarinschdäffale",
  "block.minecraft.prismarine_brick_slab": "brismarinziaglschdäffale",
  "block.minecraft.dark_prismarine_slab": "dunkls brismarinschdäffale",
  "block.minecraft.smooth_quartz": "glatter quarzblock",
  "block.minecraft.smooth_red_sandstone": "glattr roatr sandschdoi",
  "block.minecraft.smooth_sandstone": "glattr sandschdoi",
  "block.minecraft.smooth_stone": "glattr schdoi",
  "block.minecraft.bricks": "ziaglschdoi",
  "block.minecraft.tnt": "schbrengschdoff",
  "block.minecraft.bookshelf": "biacherregal",
  "block.minecraft.mossy_cobblestone": "ågmostr bruchschdoi",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fackl",
  "block.minecraft.end_rod": "endschdäble",
  "block.minecraft.chorus_plant": "koruspflänzle",
  "block.minecraft.chorus_flower": "korusbloama",
  "block.minecraft.purpur_block": "burpurblock",
  "block.minecraft.purpur_pillar": "burpursaul",
  "block.minecraft.purpur_stairs": "burpurschdiag",
  "block.minecraft.spawner": "schbånr",
  "block.minecraft.oak_stairs": "aichaholzschdiag",
  "block.minecraft.chest": "kischde",
  "block.minecraft.diamond_ore": "diamanterz",
  "block.minecraft.diamond_block": "diamantblock",
  "block.minecraft.crafting_table": "verkbänkle",
  "block.minecraft.farmland": "ackarboda",
  "block.minecraft.furnace": "ofa",
  "block.minecraft.ladder": "laitr",
  "block.minecraft.rail": "glais",
  "block.minecraft.cobblestone_stairs": "bruchschdoischdiag",
  "block.minecraft.lever": "hebl",
  "block.minecraft.stone_pressure_plate": "schdoidruckblatta",
  "block.minecraft.oak_pressure_plate": "aichaholzdruckblatta",
  "block.minecraft.spruce_pressure_plate": "fichdaholzdruckblatta",
  "block.minecraft.birch_pressure_plate": "biakaholzdruckblatta",
  "block.minecraft.jungle_pressure_plate": "dropaholzdruckblatta",
  "block.minecraft.acacia_pressure_plate": "akaziaholzdruckblatta",
  "block.minecraft.dark_oak_pressure_plate": "schvarzaichaholzdruckblatta",
  "block.minecraft.crimson_pressure_plate": "karmesindruckplatte",
  "block.minecraft.warped_pressure_plate": "wirrdruckplatte",
  "block.minecraft.polished_blackstone_pressure_plate": "polierte schwarzsteindruckplatte",
  "block.minecraft.redstone_ore": "roatschdoi-erz",
  "block.minecraft.redstone_torch": "roatschdoi-fackl",
  "block.minecraft.snow": "schnea",
  "block.minecraft.ice": "ais",
  "block.minecraft.snow_block": "schneablock",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "don",
  "block.minecraft.jukebox": "blattaschbilr",
  "block.minecraft.oak_fence": "eichenholzzaun",
  "block.minecraft.spruce_fence": "fichtenholzzaun",
  "block.minecraft.birch_fence": "birkenholzzaun",
  "block.minecraft.jungle_fence": "tropenholzzaun",
  "block.minecraft.acacia_fence": "akazienholzzaun",
  "block.minecraft.dark_oak_fence": "schwarzeichenholzzaun",
  "block.minecraft.crimson_fence": "karmesinzaun",
  "block.minecraft.warped_fence": "wirrzaun",
  "block.minecraft.pumpkin": "kirbis",
  "block.minecraft.carved_pumpkin": "gschnitztr kirbis",
  "block.minecraft.netherrack": "nethrrack",
  "block.minecraft.soul_sand": "seelasand",
  "block.minecraft.soul_soil": "seelenerde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polierter basalt",
  "block.minecraft.soul_torch": "seelenfackel",
  "block.minecraft.glowstone": "gliaschdoi",
  "block.minecraft.jack_o_lantern": "kirbisliachd",
  "block.minecraft.oak_trapdoor": "aichaholzfalldir",
  "block.minecraft.spruce_trapdoor": "fichdaholzfalldir",
  "block.minecraft.birch_trapdoor": "biakaholzfalldir",
  "block.minecraft.jungle_trapdoor": "dropaholzfalldir",
  "block.minecraft.acacia_trapdoor": "akaziaholzfalldir",
  "block.minecraft.dark_oak_trapdoor": "schvarzaichaholzfalldir",
  "block.minecraft.crimson_trapdoor": "karmesinfalltür",
  "block.minecraft.warped_trapdoor": "wirrfalltür",
  "block.minecraft.infested_stone": "befallener stein",
  "block.minecraft.infested_cobblestone": "befallener bruchstein",
  "block.minecraft.infested_stone_bricks": "befallene steinziegel",
  "block.minecraft.infested_mossy_stone_bricks": "befallene bemooste steinziegel",
  "block.minecraft.infested_cracked_stone_bricks": "befallene rissige steinziegel",
  "block.minecraft.infested_chiseled_stone_bricks": "befallene gemeißelte steinziegel",
  "block.minecraft.stone_bricks": "schdoiziagl",
  "block.minecraft.mossy_stone_bricks": "ågmoste schdoiziagl",
  "block.minecraft.cracked_stone_bricks": "rissige schdoiziagl",
  "block.minecraft.chiseled_stone_bricks": "gmaislte schdoiziagl",
  "block.minecraft.brown_mushroom_block": "braunr bilzblock",
  "block.minecraft.red_mushroom_block": "roatr bilzblock",
  "block.minecraft.mushroom_stem": "bilzschdil",
  "block.minecraft.iron_bars": "aisagittr",
  "block.minecraft.chain": "kette",
  "block.minecraft.glass_pane": "glasschaiba",
  "block.minecraft.melon": "melone",
  "block.minecraft.vine": "ranka",
  "block.minecraft.oak_fence_gate": "eichenholzzauntor",
  "block.minecraft.spruce_fence_gate": "fichtenholzzauntor",
  "block.minecraft.birch_fence_gate": "birkenholzzauntor",
  "block.minecraft.jungle_fence_gate": "tropenholzzauntor",
  "block.minecraft.acacia_fence_gate": "akazienholzzauntor",
  "block.minecraft.dark_oak_fence_gate": "schwarzeichenholzzauntor",
  "block.minecraft.crimson_fence_gate": "karmesinzauntor",
  "block.minecraft.warped_fence_gate": "wirrzauntor",
  "block.minecraft.brick_stairs": "ziaglschdiag",
  "block.minecraft.stone_brick_stairs": "schdoiziaglschdiag",
  "block.minecraft.mycelium": "miazel",
  "block.minecraft.lily_pad": "seerosablatt",
  "block.minecraft.nether_bricks": "nethrziagl",
  "block.minecraft.cracked_nether_bricks": "rissige netherziegel",
  "block.minecraft.chiseled_nether_bricks": "gemeißelte netherziegel",
  "block.minecraft.nether_brick_fence": "nethrziaglzaun",
  "block.minecraft.nether_brick_stairs": "nethrziaglschdiag",
  "block.minecraft.enchanting_table": "zaubrdisch",
  "block.minecraft.end_portal_frame": "endpfortarama",
  "block.minecraft.end_stone": "endschdoi",
  "block.minecraft.end_stone_bricks": "endschdoiziagl",
  "block.minecraft.dragon_egg": "drachaai",
  "block.minecraft.redstone_lamp": "roatschdoi-liachd",
  "block.minecraft.sandstone_stairs": "sandschdoischdiag",
  "block.minecraft.emerald_ore": "schmaragderz",
  "block.minecraft.ender_chest": "endrkischde",
  "block.minecraft.tripwire_hook": "haka",
  "block.minecraft.emerald_block": "schmaragdblock",
  "block.minecraft.spruce_stairs": "fichdaholzschdiag",
  "block.minecraft.birch_stairs": "biakaholzschdiag",
  "block.minecraft.jungle_stairs": "dropaholzschdiag",
  "block.minecraft.crimson_stairs": "karmesintreppe",
  "block.minecraft.warped_stairs": "wirrtreppe",
  "block.minecraft.command_block": "befelsblock",
  "block.minecraft.beacon": "laichdfuiar",
  "block.minecraft.cobblestone_wall": "bruchschdoimaur",
  "block.minecraft.mossy_cobblestone_wall": "ågmoste bruchschdoimaur",
  "block.minecraft.brick_wall": "ziaglschdoimaur",
  "block.minecraft.prismarine_wall": "brismarinmaur",
  "block.minecraft.red_sandstone_wall": "roate sandschdoimaur",
  "block.minecraft.mossy_stone_brick_wall": "ågmoste schdoiziaglmaur",
  "block.minecraft.granite_wall": "granitmaur",
  "block.minecraft.stone_brick_wall": "schdoiziaglmaur",
  "block.minecraft.nether_brick_wall": "nethrziaglmaur",
  "block.minecraft.andesite_wall": "andesitmaur",
  "block.minecraft.red_nether_brick_wall": "roate nethrziaglmaur",
  "block.minecraft.sandstone_wall": "sandschdoimaur",
  "block.minecraft.end_stone_brick_wall": "endschdoiziaglmaur",
  "block.minecraft.diorite_wall": "dioritmaur",
  "block.minecraft.blackstone_wall": "schwarzsteinmauer",
  "block.minecraft.polished_blackstone_wall": "polierte schwarzsteinmauer",
  "block.minecraft.polished_blackstone_brick_wall": "polierte schwarzsteinziegelmauer",
  "block.minecraft.stone_button": "schdoiknopf",
  "block.minecraft.oak_button": "aichaholzknopf",
  "block.minecraft.spruce_button": "fichdaholzknopf",
  "block.minecraft.birch_button": "biakaholzknopf",
  "block.minecraft.jungle_button": "dropaholzknopf",
  "block.minecraft.acacia_button": "akaziaholzknopf",
  "block.minecraft.dark_oak_button": "schvarzaichaholzknopf",
  "block.minecraft.crimson_button": "karmesinknopf",
  "block.minecraft.warped_button": "wirrknopf",
  "block.minecraft.polished_blackstone_button": "polierter schwarzsteinknopf",
  "block.minecraft.anvil": "amboss",
  "block.minecraft.chipped_anvil": "ågschlaganr amboss",
  "block.minecraft.damaged_anvil": "bschädigtr amboss",
  "block.minecraft.trapped_chest": "roatschdoi-kischde",
  "block.minecraft.light_weighted_pressure_plate": "fainvägblatta",
  "block.minecraft.heavy_weighted_pressure_plate": "grobvägblatta",
  "block.minecraft.daylight_detector": "tageslichtsensor",
  "block.minecraft.redstone_block": "roatschdoi-block",
  "block.minecraft.nether_quartz_ore": "nethrkvarzerz",
  "block.minecraft.hopper": "drichdr",
  "block.minecraft.chiseled_quartz_block": "gmaisltr kvarzblock",
  "block.minecraft.quartz_block": "kvarzblock",
  "block.minecraft.quartz_bricks": "quarzziegel",
  "block.minecraft.quartz_pillar": "kvarzsaul",
  "block.minecraft.quartz_stairs": "kvarzschdiag",
  "block.minecraft.activator_rail": "bedätigungsglais",
  "block.minecraft.dropper": "schbendr",
  "block.minecraft.white_terracotta": "weiße keramik",
  "block.minecraft.orange_terracotta": "orange keramik",
  "block.minecraft.magenta_terracotta": "magenta keramik",
  "block.minecraft.light_blue_terracotta": "hellblaue keramik",
  "block.minecraft.yellow_terracotta": "gelbe keramik",
  "block.minecraft.lime_terracotta": "hellgrüne keramik",
  "block.minecraft.pink_terracotta": "rosa keramik",
  "block.minecraft.gray_terracotta": "graue keramik",
  "block.minecraft.light_gray_terracotta": "hellgraue keramik",
  "block.minecraft.cyan_terracotta": "türkise keramik",
  "block.minecraft.purple_terracotta": "violette keramik",
  "block.minecraft.blue_terracotta": "blaue keramik",
  "block.minecraft.brown_terracotta": "braune keramik",
  "block.minecraft.green_terracotta": "grüne keramik",
  "block.minecraft.red_terracotta": "rote keramik",
  "block.minecraft.black_terracotta": "schwarze keramik",
  "block.minecraft.barrier": "schberre",
  "block.minecraft.iron_trapdoor": "aisafalldir",
  "block.minecraft.hay_block": "schdroibaballa",
  "block.minecraft.white_carpet": "vaisr deppich",
  "block.minecraft.orange_carpet": "oråschanr deppich",
  "block.minecraft.magenta_carpet": "rosaroatr deppich",
  "block.minecraft.light_blue_carpet": "hellblaur deppich",
  "block.minecraft.yellow_carpet": "gealr deppich",
  "block.minecraft.lime_carpet": "hellgreanr deppich",
  "block.minecraft.pink_carpet": "rosanr deppich",
  "block.minecraft.gray_carpet": "graur deppich",
  "block.minecraft.light_gray_carpet": "hellgraur deppich",
  "block.minecraft.cyan_carpet": "blaugreanr deppich",
  "block.minecraft.purple_carpet": "lillanr deppich",
  "block.minecraft.blue_carpet": "blaur deppich",
  "block.minecraft.brown_carpet": "braunr deppich",
  "block.minecraft.green_carpet": "greanr deppich",
  "block.minecraft.red_carpet": "roatr deppich",
  "block.minecraft.black_carpet": "schvarzr deppich",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "koleblock",
  "block.minecraft.packed_ice": "backais",
  "block.minecraft.acacia_stairs": "akaziaholzschdiag",
  "block.minecraft.dark_oak_stairs": "schvarzaichaholzschdiag",
  "block.minecraft.slime_block": "bäzblock",
  "block.minecraft.grass_path": "dramplpfad",
  "block.minecraft.sunflower": "sonnabloama",
  "block.minecraft.lilac": "fliadr",
  "block.minecraft.rose_bush": "rosaboscha",
  "block.minecraft.peony": "pfingschdros",
  "block.minecraft.tall_grass": "hoachs gras",
  "block.minecraft.large_fern": "groasr farn",
  "block.minecraft.white_stained_glass": "vais' glas",
  "block.minecraft.orange_stained_glass": "oråschanes glas",
  "block.minecraft.magenta_stained_glass": "rosaroats glas",
  "block.minecraft.light_blue_stained_glass": "hellblaus glas",
  "block.minecraft.yellow_stained_glass": "geales glas",
  "block.minecraft.lime_stained_glass": "hellgreas glas",
  "block.minecraft.pink_stained_glass": "rosas glas",
  "block.minecraft.gray_stained_glass": "graus glas",
  "block.minecraft.light_gray_stained_glass": "hellgraus glas",
  "block.minecraft.cyan_stained_glass": "blaugreas glas",
  "block.minecraft.purple_stained_glass": "lillas glas",
  "block.minecraft.blue_stained_glass": "blaus glas",
  "block.minecraft.brown_stained_glass": "brauns glas",
  "block.minecraft.green_stained_glass": "greas glas",
  "block.minecraft.red_stained_glass": "roats glas",
  "block.minecraft.black_stained_glass": "schvarz' glas",
  "block.minecraft.white_stained_glass_pane": "vaise glasschaiba",
  "block.minecraft.orange_stained_glass_pane": "oråschane glasschaiba",
  "block.minecraft.magenta_stained_glass_pane": "rosaroate glasschaiba",
  "block.minecraft.light_blue_stained_glass_pane": "hellblaue glasschaiba",
  "block.minecraft.yellow_stained_glass_pane": "geale glasschaiba",
  "block.minecraft.lime_stained_glass_pane": "hellgreane glasschaiba",
  "block.minecraft.pink_stained_glass_pane": "rosane glasschaiba",
  "block.minecraft.gray_stained_glass_pane": "graue glasschaiba",
  "block.minecraft.light_gray_stained_glass_pane": "hellgraue glasschaiba",
  "block.minecraft.cyan_stained_glass_pane": "blaugreane glasschaiba",
  "block.minecraft.purple_stained_glass_pane": "lillane glasschaiba",
  "block.minecraft.blue_stained_glass_pane": "blaue glasschaiba",
  "block.minecraft.brown_stained_glass_pane": "braune glasschaiba",
  "block.minecraft.green_stained_glass_pane": "greane glasschaiba",
  "block.minecraft.red_stained_glass_pane": "roate glasschaiba",
  "block.minecraft.black_stained_glass_pane": "schvarze glasschaiba",
  "block.minecraft.prismarine": "brismarin",
  "block.minecraft.prismarine_bricks": "brismarinziagl",
  "block.minecraft.dark_prismarine": "dunklr brismarin",
  "block.minecraft.prismarine_stairs": "brismarinschdiag",
  "block.minecraft.prismarine_brick_stairs": "brismarinziaglschdiag",
  "block.minecraft.dark_prismarine_stairs": "dunkle brismarinschdiag",
  "block.minecraft.sea_lantern": "sealiachd",
  "block.minecraft.red_sandstone": "roatr sandschdoi",
  "block.minecraft.chiseled_red_sandstone": "gmaisltr roatr sandschdoi",
  "block.minecraft.cut_red_sandstone": "gschnittanr roatr sandschdoi",
  "block.minecraft.red_sandstone_stairs": "roate sandschdoischdiag",
  "block.minecraft.repeating_command_block": "vidrhol-befelsblock",
  "block.minecraft.chain_command_block": "ketta-befelsblock",
  "block.minecraft.magma_block": "magmablock",
  "block.minecraft.nether_wart_block": "nethrvarzablock",
  "block.minecraft.warped_wart_block": "wirrwarzenblock",
  "block.minecraft.red_nether_bricks": "roate nethrziagl",
  "block.minecraft.bone_block": "boinablock",
  "block.minecraft.structure_void": "konschdrukzionsniks",
  "block.minecraft.observer": "beobachter",
  "block.minecraft.shulker_box": "kapslrkaschda",
  "block.minecraft.white_shulker_box": "vaisr kapslarkaschda",
  "block.minecraft.orange_shulker_box": "oråschanr kapslarkaschda",
  "block.minecraft.magenta_shulker_box": "rosaroatr kapslarkaschda",
  "block.minecraft.light_blue_shulker_box": "hellblaur kapslarkaschda",
  "block.minecraft.yellow_shulker_box": "gealr kapslarkaschda",
  "block.minecraft.lime_shulker_box": "hellgreanr kapslarkaschda",
  "block.minecraft.pink_shulker_box": "rosanr kapslarkaschda",
  "block.minecraft.gray_shulker_box": "graur kapslarkaschda",
  "block.minecraft.light_gray_shulker_box": "hellgraur kapslarkaschda",
  "block.minecraft.cyan_shulker_box": "blaugreanr kapslarkaschda",
  "block.minecraft.purple_shulker_box": "lillanr kapslarkaschda",
  "block.minecraft.blue_shulker_box": "blaur kapslarkaschda",
  "block.minecraft.brown_shulker_box": "braunr kapslarkaschda",
  "block.minecraft.green_shulker_box": "greanr kapslarkaschda",
  "block.minecraft.red_shulker_box": "roatr kapslarkaschda",
  "block.minecraft.black_shulker_box": "schvarzr kapslarkaschda",
  "block.minecraft.white_glazed_terracotta": "weiße glasierte keramik",
  "block.minecraft.orange_glazed_terracotta": "orange glasierte keramik",
  "block.minecraft.magenta_glazed_terracotta": "magenta glasierte keramik",
  "block.minecraft.light_blue_glazed_terracotta": "hellblaue glasierte keramik",
  "block.minecraft.yellow_glazed_terracotta": "gelbe glasierte keramik",
  "block.minecraft.lime_glazed_terracotta": "hellgrüne glasierte keramik",
  "block.minecraft.pink_glazed_terracotta": "rosa glasierte keramik",
  "block.minecraft.gray_glazed_terracotta": "graue glasierte keramik",
  "block.minecraft.light_gray_glazed_terracotta": "hellgraue glasierte keramik",
  "block.minecraft.cyan_glazed_terracotta": "türkise glasierte keramik",
  "block.minecraft.purple_glazed_terracotta": "violette glasierte keramik",
  "block.minecraft.blue_glazed_terracotta": "blaue glasierte keramik",
  "block.minecraft.brown_glazed_terracotta": "braune glasierte keramik",
  "block.minecraft.green_glazed_terracotta": "grüne glasierte keramik",
  "block.minecraft.red_glazed_terracotta": "rote glasierte keramik",
  "block.minecraft.black_glazed_terracotta": "schwarze glasierte keramik",
  "block.minecraft.white_concrete": "vaisr beto",
  "block.minecraft.orange_concrete": "oråschanr beto",
  "block.minecraft.magenta_concrete": "rosaroatr beto",
  "block.minecraft.light_blue_concrete": "hellblaur beto",
  "block.minecraft.yellow_concrete": "gealr beto",
  "block.minecraft.lime_concrete": "hellgreanr beto",
  "block.minecraft.pink_concrete": "rosanr beto",
  "block.minecraft.gray_concrete": "graur beto",
  "block.minecraft.light_gray_concrete": "hellgraur beto",
  "block.minecraft.cyan_concrete": "blaugreanr beto",
  "block.minecraft.purple_concrete": "lillanr beto",
  "block.minecraft.blue_concrete": "blaur beto",
  "block.minecraft.brown_concrete": "braunr beto",
  "block.minecraft.green_concrete": "greanr beto",
  "block.minecraft.red_concrete": "roatr beto",
  "block.minecraft.black_concrete": "schvarzr beto",
  "block.minecraft.white_concrete_powder": "vaisr druckabeto",
  "block.minecraft.orange_concrete_powder": "oråschanr druckabeto",
  "block.minecraft.magenta_concrete_powder": "rosaroatr druckabeto",
  "block.minecraft.light_blue_concrete_powder": "hellblaur druckabeto",
  "block.minecraft.yellow_concrete_powder": "gealr druckabeto",
  "block.minecraft.lime_concrete_powder": "hellgreanr druckabeto",
  "block.minecraft.pink_concrete_powder": "rosanr druckabeto",
  "block.minecraft.gray_concrete_powder": "graur druckabeto",
  "block.minecraft.light_gray_concrete_powder": "hellgraur druckabeto",
  "block.minecraft.cyan_concrete_powder": "blaugreanr druckabeto",
  "block.minecraft.purple_concrete_powder": "lillanr druckabeto",
  "block.minecraft.blue_concrete_powder": "blaur druckabeto",
  "block.minecraft.brown_concrete_powder": "braunr druckabeto",
  "block.minecraft.green_concrete_powder": "greanr druckabeto",
  "block.minecraft.red_concrete_powder": "roatr druckabeto",
  "block.minecraft.black_concrete_powder": "schvarzr druckabeto",
  "block.minecraft.turtle_egg": "schildkrottaai",
  "block.minecraft.dead_tube_coral_block": "doatr orglkorallablock",
  "block.minecraft.dead_brain_coral_block": "doatr hirakorallablock",
  "block.minecraft.dead_bubble_coral_block": "doatr blasakorallablock",
  "block.minecraft.dead_fire_coral_block": "doatr fuiarkorallablock",
  "block.minecraft.dead_horn_coral_block": "doatr gvaikorallablock",
  "block.minecraft.tube_coral_block": "orglkorallablock",
  "block.minecraft.brain_coral_block": "hirakorallablock",
  "block.minecraft.bubble_coral_block": "blasakorallablock",
  "block.minecraft.fire_coral_block": "fuiarkorallablock",
  "block.minecraft.horn_coral_block": "gvaikorallablock",
  "block.minecraft.tube_coral": "orglkoralla",
  "block.minecraft.brain_coral": "hirakoralla",
  "block.minecraft.bubble_coral": "blasakoralla",
  "block.minecraft.fire_coral": "fuiarkoralla",
  "block.minecraft.horn_coral": "gvaikoralla",
  "block.minecraft.dead_brain_coral": "doate hirakoralla",
  "block.minecraft.dead_bubble_coral": "doate blasakoralla",
  "block.minecraft.dead_fire_coral": "doate fuiarkoralla",
  "block.minecraft.dead_horn_coral": "doate gvaihkoralla",
  "block.minecraft.dead_tube_coral": "doate orglkoralla",
  "block.minecraft.tube_coral_fan": "orglkorallafächr",
  "block.minecraft.brain_coral_fan": "hirakorallafächr",
  "block.minecraft.bubble_coral_fan": "blasakorallafächr",
  "block.minecraft.fire_coral_fan": "fuiarkorallafächr",
  "block.minecraft.horn_coral_fan": "gvaikorallafächr",
  "block.minecraft.dead_tube_coral_fan": "doatr orglkorallafächr",
  "block.minecraft.dead_brain_coral_fan": "doatr hirakorallafächr",
  "block.minecraft.dead_bubble_coral_fan": "doatr blasakorallafächr",
  "block.minecraft.dead_fire_coral_fan": "doatr fuiarkorallafächr",
  "block.minecraft.dead_horn_coral_fan": "doatr gvaikorallafächr",
  "block.minecraft.blue_ice": "blauais",
  "block.minecraft.conduit": "akvisatr",
  "block.minecraft.polished_granite_stairs": "boliarte granitschdiag",
  "block.minecraft.smooth_red_sandstone_stairs": "glatte roate sandschdoischdiag",
  "block.minecraft.mossy_stone_brick_stairs": "ågmoste schdoiziaglschdiag",
  "block.minecraft.polished_diorite_stairs": "boliarte dioritschdiag",
  "block.minecraft.mossy_cobblestone_stairs": "ågmoste bruchschdoischdiag",
  "block.minecraft.end_stone_brick_stairs": "endschdoiziaglschdiag",
  "block.minecraft.stone_stairs": "schdoischdiag",
  "block.minecraft.smooth_sandstone_stairs": "glatte sandschdoischdiag",
  "block.minecraft.smooth_quartz_stairs": "glatte kvarzschdiag",
  "block.minecraft.granite_stairs": "granitschdiag",
  "block.minecraft.andesite_stairs": "andesitschdiag",
  "block.minecraft.red_nether_brick_stairs": "roate nethrziaglschdiag",
  "block.minecraft.polished_andesite_stairs": "boliarte andesitschdiag",
  "block.minecraft.diorite_stairs": "dioritschdiag",
  "block.minecraft.polished_granite_slab": "boliarts granitschdäffale",
  "block.minecraft.smooth_red_sandstone_slab": "glatts roats sandschdoischdäffale",
  "block.minecraft.mossy_stone_brick_slab": "ågmosts schdoiziaglschdäffale",
  "block.minecraft.polished_diorite_slab": "boliarts dioritschdäffale",
  "block.minecraft.mossy_cobblestone_slab": "ågmosts bruchschdoischdäffale",
  "block.minecraft.end_stone_brick_slab": "endschdoiziaglschdäffale",
  "block.minecraft.smooth_sandstone_slab": "glatts sandschdoischdäffale",
  "block.minecraft.smooth_quartz_slab": "glatts kvarzschdäffale",
  "block.minecraft.granite_slab": "granitschdäffale",
  "block.minecraft.andesite_slab": "andesitschdäffale",
  "block.minecraft.red_nether_brick_slab": "roats nethrziaglschdäffale",
  "block.minecraft.polished_andesite_slab": "boliarts andesitschdäffale",
  "block.minecraft.diorite_slab": "dioritschdäffale",
  "block.minecraft.scaffolding": "grischd",
  "block.minecraft.iron_door": "aisadir",
  "block.minecraft.oak_door": "aichaholzdir",
  "block.minecraft.spruce_door": "fichdaholzdir",
  "block.minecraft.birch_door": "biakaholzdir",
  "block.minecraft.jungle_door": "dropaholzdir",
  "block.minecraft.acacia_door": "akaziaholzdir",
  "block.minecraft.dark_oak_door": "schvarzaichaholzdir",
  "block.minecraft.crimson_door": "karmesintür",
  "block.minecraft.warped_door": "wirrtür",
  "block.minecraft.repeater": "roatschdoi-frschdärkar",
  "block.minecraft.comparator": "roatschdoi-komparatr",
  "block.minecraft.structure_block": "konschdrukzionsblock",
  "block.minecraft.jigsaw": "frbundblock",
  "item.minecraft.turtle_helmet": "schildkrötenpanzer□□auf dem kopf:□+2 rischdung",
  "item.minecraft.scute": "horaschild",
  "item.minecraft.iron_shovel": "aisaschaufl□□in der haupthand:□+3.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.iron_pickaxe": "aisabickl□□in der haupthand:□+3 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.iron_axe": "aisaakschd□□in der haupthand:□+8 angriffsschaden□-3.1 angriffsgeschwindigkeit",
  "item.minecraft.flint_and_steel": "fuiarzuig",
  "item.minecraft.apple": "epfl",
  "item.minecraft.bow": "boga",
  "item.minecraft.arrow": "pfail",
  "item.minecraft.coal": "kole",
  "item.minecraft.charcoal": "holzkole",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "aisabarra",
  "item.minecraft.gold_ingot": "goldbarra",
  "item.minecraft.netherite_ingot": "nethritbarra",
  "item.minecraft.netherite_scrap": "nethritblatta",
  "item.minecraft.iron_sword": "aisaschvert□□in der haupthand:□+5 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.wooden_sword": "holzschvert□□in der haupthand:□+3 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.wooden_shovel": "holzschaufl□□in der haupthand:□+1.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.wooden_pickaxe": "holzbickl□□in der haupthand:□+1 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.wooden_axe": "holzakschd□□in der haupthand:□+6 angriffsschaden□-3.2 angriffsgeschwindigkeit",
  "item.minecraft.stone_sword": "schdoischvert□□in der haupthand:□+4 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.stone_shovel": "schdoischaufl□□in der haupthand:□+2.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.stone_pickaxe": "schdoibickl□□in der haupthand:□+2 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.stone_axe": "schdoiakschd□□in der haupthand:□+8 angriffsschaden□-3.2 angriffsgeschwindigkeit",
  "item.minecraft.diamond_sword": "diamantschvert□□in der haupthand:□+6 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.diamond_shovel": "diamantschaufl□□in der haupthand:□+4.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.diamond_pickaxe": "diamantbickl□□in der haupthand:□+4 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.diamond_axe": "diamantakschd□□in der haupthand:□+8 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.stick": "schdecka",
  "item.minecraft.bowl": "schissl",
  "item.minecraft.mushroom_stew": "pilzsuppa",
  "item.minecraft.golden_sword": "goldschvert□□in der haupthand:□+3 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.golden_shovel": "goldschaufl□□in der haupthand:□+1.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.golden_pickaxe": "goldbickl□□in der haupthand:□+1 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.golden_axe": "goldakschd□□in der haupthand:□+6 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.netherite_sword": "nethritschvert□□in der haupthand:□+7 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.netherite_shovel": "nethritschaufl□□in der haupthand:□+5.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.netherite_pickaxe": "nethritbickl□□in der haupthand:□+5 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.netherite_axe": "nethritakschd□□in der haupthand:□+9 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.string": "schbaga",
  "item.minecraft.feather": "fedr",
  "item.minecraft.gunpowder": "schvarzbulfar",
  "item.minecraft.wooden_hoe": "holzfeldbickl□□in der haupthand:□-3 angriffsgeschwindigkeit",
  "item.minecraft.stone_hoe": "schdoifeldbickl□□in der haupthand:□-2 angriffsgeschwindigkeit",
  "item.minecraft.iron_hoe": "aisafeldbickl□□in der haupthand:□-1 angriffsgeschwindigkeit",
  "item.minecraft.diamond_hoe": "diamantfeldbickl□□in der haupthand:",
  "item.minecraft.golden_hoe": "goldfeldbickl□□in der haupthand:□-3 angriffsgeschwindigkeit",
  "item.minecraft.netherite_hoe": "nethritfeldbickl□□in der haupthand:",
  "item.minecraft.wheat_seeds": "vaizakera",
  "item.minecraft.wheat": "vaiza",
  "item.minecraft.bread": "seml",
  "item.minecraft.leather_helmet": "leadrkappa□□auf dem kopf:□+1 rischdung",
  "item.minecraft.leather_chestplate": "leadrjuppa□□am körper:□+3 rischdung",
  "item.minecraft.leather_leggings": "leadrhos□□an den beinen:□+2 rischdung",
  "item.minecraft.leather_boots": "leadrschdifl□□an den füßen:□+1 rischdung",
  "item.minecraft.chainmail_helmet": "kettahauba□□auf dem kopf:□+2 rischdung",
  "item.minecraft.chainmail_chestplate": "kettahemad□□am körper:□+5 rischdung",
  "item.minecraft.chainmail_leggings": "kettahos□□an den beinen:□+4 rischdung",
  "item.minecraft.chainmail_boots": "kettaschdifl□□an den füßen:□+1 rischdung",
  "item.minecraft.iron_helmet": "aisahelm□□auf dem kopf:□+2 rischdung",
  "item.minecraft.iron_chestplate": "aisaharnisch□□am körper:□+6 rischdung",
  "item.minecraft.iron_leggings": "aisafuasschutz□□an den beinen:□+5 rischdung",
  "item.minecraft.iron_boots": "aisaschdifl□□an den füßen:□+2 rischdung",
  "item.minecraft.diamond_helmet": "diamanthelm□□auf dem kopf:□+3 rischdung□+2 rüstungshärte",
  "item.minecraft.diamond_chestplate": "diamantharnisch□□am körper:□+8 rischdung□+2 rüstungshärte",
  "item.minecraft.diamond_leggings": "diamantfuasschutz□□an den beinen:□+6 rischdung□+2 rüstungshärte",
  "item.minecraft.diamond_boots": "diamantschdifl□□an den füßen:□+3 rischdung□+2 rüstungshärte",
  "item.minecraft.golden_helmet": "goldhelm□□auf dem kopf:□+2 rischdung",
  "item.minecraft.golden_chestplate": "goldharnisch□□am körper:□+5 rischdung",
  "item.minecraft.golden_leggings": "goldfuasschutz□□an den beinen:□+3 rischdung",
  "item.minecraft.golden_boots": "goldschdifl□□an den füßen:□+1 rischdung",
  "item.minecraft.netherite_helmet": "nethrithelm□□auf dem kopf:□+3 rischdung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.netherite_chestplate": "nethritharnisch□□am körper:□+8 rischdung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.netherite_leggings": "nethritfuasschutz□□an den beinen:□+6 rischdung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.netherite_boots": "nethritschdifl□□an den füßen:□+3 rischdung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.flint": "fuiarschdoi",
  "item.minecraft.porkchop": "ros sucklschnitzl",
  "item.minecraft.cooked_porkchop": "bråtanes sucklschnitzl",
  "item.minecraft.painting": "bild",
  "item.minecraft.golden_apple": "goldepfl",
  "item.minecraft.enchanted_golden_apple": "frzaubartr goldepfl",
  "block.minecraft.oak_sign": "aichaholzschildle",
  "block.minecraft.spruce_sign": "fichdaholzschildle",
  "block.minecraft.birch_sign": "biakaholzschildle",
  "block.minecraft.jungle_sign": "dropaholzschildle",
  "block.minecraft.acacia_sign": "akaziaholzschildle",
  "block.minecraft.dark_oak_sign": "schvarzaichaholzschildle",
  "block.minecraft.crimson_sign": "karmesinschild",
  "block.minecraft.warped_sign": "wirrschild",
  "item.minecraft.bucket": "kibl",
  "item.minecraft.water_bucket": "vassrkibl",
  "item.minecraft.lava_bucket": "lavakibl",
  "item.minecraft.minecart": "karra",
  "item.minecraft.saddle": "sattl",
  "item.minecraft.redstone": "roatschdoi-schdaub",
  "item.minecraft.snowball": "schneaball",
  "item.minecraft.oak_boat": "aichaholzbot",
  "item.minecraft.leather": "leadr",
  "item.minecraft.milk_bucket": "millkibl",
  "item.minecraft.pufferfish_bucket": "kuglfischkibl",
  "item.minecraft.salmon_bucket": "lakskibl",
  "item.minecraft.cod_bucket": "dorschkibl",
  "item.minecraft.tropical_fish_bucket": "dropafischkibl",
  "item.minecraft.brick": "ziagl",
  "item.minecraft.clay_ball": "donbolla",
  "block.minecraft.dried_kelp_block": "druckanr seadangblock",
  "item.minecraft.paper": "bapiar",
  "item.minecraft.book": "buach",
  "item.minecraft.slime_ball": "bäzbolla",
  "item.minecraft.chest_minecart": "kischdakarra",
  "item.minecraft.furnace_minecart": "ofakarra",
  "item.minecraft.egg": "ai",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "angl",
  "item.minecraft.clock": "uar",
  "item.minecraft.glowstone_dust": "gliaschdoischdaub",
  "item.minecraft.cod": "roar dorsch",
  "item.minecraft.salmon": "roar laks",
  "item.minecraft.tropical_fish": "dropafisch",
  "item.minecraft.pufferfish": "kuglfisch",
  "item.minecraft.cooked_cod": "bråtanar dorsch",
  "item.minecraft.cooked_salmon": "bråtanar laks",
  "item.minecraft.ink_sac": "dintabaitl",
  "item.minecraft.red_dye": "roter farbstoff",
  "item.minecraft.green_dye": "grüner farbstoff",
  "item.minecraft.cocoa_beans": "kakaubona",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "violetter farbstoff",
  "item.minecraft.cyan_dye": "türkiser farbstoff",
  "item.minecraft.light_gray_dye": "hellgrauer farbstoff",
  "item.minecraft.gray_dye": "grauer farbstoff",
  "item.minecraft.pink_dye": "rosa farbstoff",
  "item.minecraft.lime_dye": "hellgrüner farbstoff",
  "item.minecraft.yellow_dye": "gelber farbstoff",
  "item.minecraft.light_blue_dye": "hellblauer farbstoff",
  "item.minecraft.magenta_dye": "magenta farbstoff",
  "item.minecraft.orange_dye": "oranger farbstoff",
  "item.minecraft.bone_meal": "boinamel",
  "item.minecraft.blue_dye": "blauer farbstoff",
  "item.minecraft.brown_dye": "brauner farbstoff",
  "item.minecraft.black_dye": "schwarzer farbstoff",
  "item.minecraft.white_dye": "weißer farbstoff",
  "item.minecraft.bone": "boina",
  "item.minecraft.sugar": "zuckr",
  "block.minecraft.cake": "kuacha",
  "block.minecraft.white_bed": "vais' bettle",
  "block.minecraft.orange_bed": "oråschanes bettle",
  "block.minecraft.magenta_bed": "rosaroats bettle",
  "block.minecraft.light_blue_bed": "hellblaus bettle",
  "block.minecraft.yellow_bed": "geales bettle",
  "block.minecraft.lime_bed": "hellgreas bettle",
  "block.minecraft.pink_bed": "rosas bettle",
  "block.minecraft.gray_bed": "graus bettle",
  "block.minecraft.light_gray_bed": "hellgraus bettle",
  "block.minecraft.cyan_bed": "blaugreas bettle",
  "block.minecraft.purple_bed": "lillas bettle",
  "block.minecraft.blue_bed": "blaus bettle",
  "block.minecraft.brown_bed": "brauns bettle",
  "block.minecraft.green_bed": "greas bettle",
  "block.minecraft.red_bed": "roats bettle",
  "block.minecraft.black_bed": "schvarz' bettle",
  "item.minecraft.cookie": "laible",
  "item.minecraft.filled_map": "karte□#0",
  "item.minecraft.shears": "schere",
  "item.minecraft.melon_slice": "melonaschaiba",
  "item.minecraft.dried_kelp": "drocknetr seedang",
  "item.minecraft.pumpkin_seeds": "kirbiskera",
  "item.minecraft.melon_seeds": "melonakera",
  "item.minecraft.beef": "ros rindsschnitzl",
  "item.minecraft.cooked_beef": "bråtanes rindsschnitzl",
  "item.minecraft.chicken": "roar gockl",
  "item.minecraft.cooked_chicken": "bråtanar gockl",
  "item.minecraft.rotten_flesh": "fauls flaisch",
  "item.minecraft.ender_pearl": "endrberle",
  "item.minecraft.blaze_rod": "loaschdäble",
  "item.minecraft.ghast_tear": "ghast-träne",
  "item.minecraft.gold_nugget": "goldbolla",
  "item.minecraft.nether_wart": "nethrvarze",
  "item.minecraft.potion": "nicht braubarer trank□wirkungslos",
  "item.minecraft.glass_bottle": "glasguttr",
  "item.minecraft.spider_eye": "schbinnaog",
  "item.minecraft.fermented_spider_eye": "gärtes schbinnaog",
  "item.minecraft.blaze_powder": "loaschdaub",
  "item.minecraft.magma_cream": "magmakrem",
  "block.minecraft.brewing_stand": "brauschdändle",
  "block.minecraft.cauldron": "dopf",
  "item.minecraft.ender_eye": "endr-og",
  "item.minecraft.glistering_melon_slice": "glitzernde melonenscheibe",
  "item.minecraft.bat_spawn_egg": "fleadrmaus-schbån-ai",
  "item.minecraft.bee_spawn_egg": "bia-schbån-ai",
  "item.minecraft.blaze_spawn_egg": "loa-schbån-ai",
  "item.minecraft.cat_spawn_egg": "khatz-schbån-ai",
  "item.minecraft.cave_spider_spawn_egg": "helaschbinna-schbån-ai",
  "item.minecraft.chicken_spawn_egg": "gockl-schbån-ai",
  "item.minecraft.cod_spawn_egg": "dorsch-schbån-ai",
  "item.minecraft.cow_spawn_egg": "kua-schbån-ai",
  "item.minecraft.creeper_spawn_egg": "kripr-schbån-ai",
  "item.minecraft.dolphin_spawn_egg": "delfin-schbån-ai",
  "item.minecraft.donkey_spawn_egg": "esl-schbån-ai",
  "item.minecraft.drowned_spawn_egg": "asoffanr-schbån-ai",
  "item.minecraft.elder_guardian_spawn_egg": "groasvächdr-schbån-ai",
  "item.minecraft.enderman_spawn_egg": "endrmå-schbån-ai",
  "item.minecraft.endermite_spawn_egg": "endrmita-schbån-ai",
  "item.minecraft.evoker_spawn_egg": "zaubrar-schbån-ai",
  "item.minecraft.fox_spawn_egg": "fuks-schbån-ai",
  "item.minecraft.ghast_spawn_egg": "ghaschd-schbån-ai",
  "item.minecraft.guardian_spawn_egg": "vächdr-schbån-ai",
  "item.minecraft.hoglin_spawn_egg": "hoglin-schbån-ai",
  "item.minecraft.horse_spawn_egg": "ros-schbån-ai",
  "item.minecraft.husk_spawn_egg": "viaschdazombi-schbån-ai",
  "item.minecraft.llama_spawn_egg": "lama-schbån-ai",
  "item.minecraft.magma_cube_spawn_egg": "magmavirfl-schbån-ai",
  "item.minecraft.mooshroom_spawn_egg": "kuatinosus-schbån-ai",
  "item.minecraft.mule_spawn_egg": "muli-schbån-ai",
  "item.minecraft.ocelot_spawn_egg": "vildkhatz-schbån-ai",
  "item.minecraft.panda_spawn_egg": "bambusbära-schbån-ai",
  "item.minecraft.parrot_spawn_egg": "bapagaia-schbån-ai",
  "item.minecraft.phantom_spawn_egg": "fantom-schbån-ai",
  "item.minecraft.pig_spawn_egg": "suckl-schbån-ai",
  "item.minecraft.piglin_spawn_egg": "biglin-schbån-ai",
  "item.minecraft.pillager_spawn_egg": "blindrar-schbån-ai",
  "item.minecraft.polar_bear_spawn_egg": "aisbära-schbån-ai",
  "item.minecraft.pufferfish_spawn_egg": "kuglfisch-schbån-ai",
  "item.minecraft.rabbit_spawn_egg": "hasa-schbån-ai",
  "item.minecraft.ravager_spawn_egg": "frviaschdr-schbån-ai",
  "item.minecraft.salmon_spawn_egg": "laks-schbån-ai",
  "item.minecraft.sheep_spawn_egg": "schåf-schbån-ai",
  "item.minecraft.shulker_spawn_egg": "kapslar-schbån-ai",
  "item.minecraft.silverfish_spawn_egg": "silbrfischle-schbån-ai",
  "item.minecraft.skeleton_spawn_egg": "schgelett-schbån-ai",
  "item.minecraft.skeleton_horse_spawn_egg": "schgelettros-schbån-ai",
  "item.minecraft.slime_spawn_egg": "bäz-schbån-ai",
  "item.minecraft.spider_spawn_egg": "schbinna-schbån-ai",
  "item.minecraft.squid_spawn_egg": "dintafisch-schbån-ai",
  "item.minecraft.stray_spawn_egg": "aisvandrar-schbån-ai",
  "item.minecraft.strider_spawn_egg": "schreiter-spawn-ei",
  "item.minecraft.trader_llama_spawn_egg": "händlarlama-schbån-ai",
  "item.minecraft.tropical_fish_spawn_egg": "dropafisch-schbån-ai",
  "item.minecraft.turtle_spawn_egg": "schildkrott-schbån-ai",
  "item.minecraft.vex_spawn_egg": "blåggaischd-schbån-ai",
  "item.minecraft.villager_spawn_egg": "derflar-schbån-ai",
  "item.minecraft.vindicator_spawn_egg": "dianr-schbån-ai",
  "item.minecraft.wandering_trader_spawn_egg": "fahrender-händler-spawn-ei",
  "item.minecraft.witch_spawn_egg": "heksa-schbån-ai",
  "item.minecraft.wither_skeleton_spawn_egg": "withrschgelett-schbån-ai",
  "item.minecraft.wolf_spawn_egg": "volf-schbån-ai",
  "item.minecraft.zoglin_spawn_egg": "zoglin-schbån-ai",
  "item.minecraft.zombie_spawn_egg": "zombi-schbån-ai",
  "item.minecraft.zombie_horse_spawn_egg": "zombiros-schbån-ai",
  "item.minecraft.zombie_villager_spawn_egg": "zombiderflar-schbån-ai",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifiziartr-biglin-schbån-ai",
  "item.minecraft.experience_bottle": "erfarungsguttr",
  "item.minecraft.fire_charge": "fuiarbolla",
  "item.minecraft.writable_book": "buach ond fedr",
  "item.minecraft.written_book": "beschriebenes buch",
  "item.minecraft.emerald": "schmaragd",
  "item.minecraft.item_frame": "rama",
  "block.minecraft.flower_pot": "bloamadopf",
  "item.minecraft.carrot": "geale riab",
  "item.minecraft.potato": "bodabira",
  "item.minecraft.baked_potato": "bachane bodabira",
  "item.minecraft.poisonous_potato": "giftige bodabira",
  "item.minecraft.map": "leere karte",
  "item.minecraft.golden_carrot": "goldriab",
  "block.minecraft.skeleton_skull": "schgelettschädl",
  "block.minecraft.wither_skeleton_skull": "withrschgelettschädl",
  "block.minecraft.player_head": "schbilrgrind",
  "block.minecraft.zombie_head": "zombigrind",
  "block.minecraft.creeper_head": "kriprgrind",
  "block.minecraft.dragon_head": "drachakopf",
  "item.minecraft.carrot_on_a_stick": "karottenrute",
  "item.minecraft.warped_fungus_on_a_stick": "wirrpilzrute",
  "item.minecraft.nether_star": "nethrschderala",
  "item.minecraft.pumpkin_pie": "kirbiskuacha",
  "item.minecraft.firework_rocket": "fuiarwerksrakete",
  "item.minecraft.firework_star": "fuiarwerksschderala",
  "item.minecraft.enchanted_book": "frzaubrts buach",
  "item.minecraft.nether_brick": "nethrziagl",
  "item.minecraft.quartz": "nethrkvarz",
  "item.minecraft.tnt_minecart": "schbrengschdoffkarra",
  "item.minecraft.hopper_minecart": "drichdrkarra",
  "item.minecraft.prismarine_shard": "brismarinscherbe",
  "item.minecraft.prismarine_crystals": "brismarinkrischdalle",
  "item.minecraft.rabbit": "roar has",
  "item.minecraft.cooked_rabbit": "bråtanar has",
  "item.minecraft.rabbit_stew": "hasagulasch",
  "item.minecraft.rabbit_foot": "hasapfote",
  "item.minecraft.rabbit_hide": "hasafell",
  "item.minecraft.armor_stand": "rischdungsschdändr",
  "item.minecraft.iron_horse_armor": "eiserner rossharnisch",
  "item.minecraft.golden_horse_armor": "goldener rossharnisch",
  "item.minecraft.diamond_horse_armor": "diamantener rossharnisch",
  "item.minecraft.leather_horse_armor": "lederner rossharnisch",
  "item.minecraft.lead": "schdrick",
  "item.minecraft.name_tag": "nåmaschildle",
  "item.minecraft.command_block_minecart": "befelsblockkarra",
  "item.minecraft.mutton": "ros schåf",
  "item.minecraft.cooked_mutton": "bråtanes schåf",
  "block.minecraft.white_banner": "vais' bannr",
  "block.minecraft.orange_banner": "oråschanes bannr",
  "block.minecraft.magenta_banner": "rosaroats bannr",
  "block.minecraft.light_blue_banner": "hellblaus bannr",
  "block.minecraft.yellow_banner": "geales bannr",
  "block.minecraft.lime_banner": "hellgreas bannr",
  "block.minecraft.pink_banner": "rosas bannr",
  "block.minecraft.gray_banner": "graus bannr",
  "block.minecraft.light_gray_banner": "hellgraus bannr",
  "block.minecraft.cyan_banner": "blaugreas bannr",
  "block.minecraft.purple_banner": "lillas bannr",
  "block.minecraft.blue_banner": "blaus bannr",
  "block.minecraft.brown_banner": "brauns bannr",
  "block.minecraft.green_banner": "greas bannr",
  "block.minecraft.red_banner": "roats bannr",
  "block.minecraft.black_banner": "schvarz' bannr",
  "item.minecraft.end_crystal": "endrkrischdall",
  "item.minecraft.chorus_fruit": "korusepfl",
  "item.minecraft.popped_chorus_fruit": "blatzta korusepfl",
  "item.minecraft.beetroot": "randa",
  "item.minecraft.beetroot_seeds": "randasama",
  "item.minecraft.beetroot_soup": "randasuppa",
  "item.minecraft.dragon_breath": "drachaschnauf",
  "item.minecraft.splash_potion": "nicht braubarer wurftrank□wirkungslos",
  "item.minecraft.spectral_arrow": "schbektralpfail",
  "item.minecraft.tipped_arrow": "nicht herstellbarer getränkter pfeil□wirkungslos",
  "item.minecraft.lingering_potion": "nicht braubarer verweiltrank□wirkungslos",
  "item.minecraft.shield": "schild",
  "item.minecraft.elytra": "eliatra",
  "item.minecraft.spruce_boat": "fichdaholzbot",
  "item.minecraft.birch_boat": "biakaholzbot",
  "item.minecraft.jungle_boat": "dropaholzbot",
  "item.minecraft.acacia_boat": "akaziaholzbot",
  "item.minecraft.dark_oak_boat": "schvarzaichaholzbot",
  "item.minecraft.totem_of_undying": "totem der unsterblichkeit",
  "item.minecraft.shulker_shell": "kapslrschala",
  "item.minecraft.iron_nugget": "aisabolla",
  "item.minecraft.knowledge_book": "buach fo dr vaishait",
  "item.minecraft.debug_stick": "debug-schdecka",
  "item.minecraft.music_disc_13": "schallblatta□c418 - 13",
  "item.minecraft.music_disc_cat": "schallblatta□c418 - khatz",
  "item.minecraft.music_disc_blocks": "schallblatta□c418 - blecka",
  "item.minecraft.music_disc_chirp": "schallblatta□c418 - zirp",
  "item.minecraft.music_disc_far": "schallblatta□c418 - far",
  "item.minecraft.music_disc_mall": "schallblatta□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schallblatta□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schallblatta□c418 - schdal",
  "item.minecraft.music_disc_strad": "schallblatta□c418 - schdrad",
  "item.minecraft.music_disc_ward": "schallblatta□c418 - ward",
  "item.minecraft.music_disc_11": "schallblatta□c418 - 11",
  "item.minecraft.music_disc_wait": "schallblatta□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schallblatta□lena raine - pigstep",
  "item.minecraft.trident": "draizack□□in der haupthand:□+8 angriffsschaden□-2.9 angriffsgeschwindigkeit",
  "item.minecraft.phantom_membrane": "fantomhaut",
  "item.minecraft.nautilus_shell": "nautilusschale",
  "item.minecraft.heart_of_the_sea": "herz fom mär",
  "item.minecraft.crossbow": "armbruschd",
  "item.minecraft.suspicious_stew": "seltsame suppe",
  "block.minecraft.loom": "vebschdual",
  "item.minecraft.flower_banner_pattern": "bannervorlage□bloama",
  "item.minecraft.creeper_banner_pattern": "bannervorlage□kripr",
  "item.minecraft.skull_banner_pattern": "bannervorlage□schädl",
  "item.minecraft.mojang_banner_pattern": "bannervorlage□dings",
  "item.minecraft.globe_banner_pattern": "bannervorlage□globus",
  "item.minecraft.piglin_banner_pattern": "bannervorlage□schnauze",
  "block.minecraft.composter": "komposchdr",
  "block.minecraft.barrel": "fass",
  "block.minecraft.smoker": "räucherofen",
  "block.minecraft.blast_furnace": "schmelzofen",
  "block.minecraft.cartography_table": "kartentisch",
  "block.minecraft.fletching_table": "bognertisch",
  "block.minecraft.grindstone": "schleifstein",
  "block.minecraft.lectern": "lesepult",
  "block.minecraft.smithing_table": "schmiedetisch",
  "block.minecraft.stonecutter": "steinsäge",
  "block.minecraft.bell": "glocke",
  "block.minecraft.lantern": "funzl",
  "block.minecraft.soul_lantern": "selafunzl",
  "item.minecraft.sweet_berries": "siasberala",
  "block.minecraft.campfire": "lagrfuiar",
  "block.minecraft.soul_campfire": "seelenlagerfeuer",
  "block.minecraft.shroomlight": "pilzlicht",
  "item.minecraft.honeycomb": "honigvab",
  "block.minecraft.bee_nest": "bienennest",
  "block.minecraft.beehive": "bienenstock",
  "item.minecraft.honey_bottle": "honigguttr",
  "block.minecraft.honey_block": "honigblock",
  "block.minecraft.honeycomb_block": "honigwabenblock",
  "block.minecraft.lodestone": "leitstein",
  "block.minecraft.netherite_block": "nethritblock",
  "block.minecraft.ancient_debris": "antiker schrott",
  "block.minecraft.target": "zielblock",
  "block.minecraft.crying_obsidian": "weinender obsidian",
  "block.minecraft.blackstone": "schwarzstein",
  "block.minecraft.blackstone_slab": "schwarzsteinstufe",
  "block.minecraft.blackstone_stairs": "schwarzsteintreppe",
  "block.minecraft.gilded_blackstone": "golddurchzogener schwarzstein",
  "block.minecraft.polished_blackstone": "polierter schwarzstein",
  "block.minecraft.polished_blackstone_slab": "polierte schwarzsteinstufe",
  "block.minecraft.polished_blackstone_stairs": "polierte schwarzsteintreppe",
  "block.minecraft.chiseled_polished_blackstone": "gemeißelter polierter schwarzstein",
  "block.minecraft.polished_blackstone_bricks": "polierte schwarzsteinziegel",
  "block.minecraft.polished_blackstone_brick_slab": "polierte schwarzsteinziegelstufe",
  "block.minecraft.polished_blackstone_brick_stairs": "polierte schwarzsteinziegeltreppe",
  "block.minecraft.cracked_polished_blackstone_bricks": "rissige polierte schwarzsteinziegel",
  "block.minecraft.respawn_anchor": "seelenanker",
}
export const swg = items; 
